import { useEffect, useRef, useState } from "react";
import styles from "./OtpCode.module.scss";
import { AmazonService } from "../../../services/amazon.service";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import OrderRow from "../../../components/pages/courier/OrderRow";
import {
  AmazonOtpDataType,
  ApiPaginationResponse,
  CountriesDataType,
} from "../../../interface/site.interface";
import amazoneditBtn from "../../../assets/images/otp/fluent_status-24-regular.svg";
import InputComponent from "../../../components/shared/input/InputComponent";
import ServiceBalance from "../../../assets/images/otp/Service Balance Icon.svg";
import TransparationBalance from "../../../assets/images/otp/Transportation Balance Icon.svg";
import MainButton from "../../../components/shared/button/MainButton";
import Spinner from "../../../components/shared/spinner/Spinner";
import Card from "../../../components/pages/card/Card";
import closeIcon from "../../../assets/images/referal/Close Icon.svg";
import ArrowImage from "../../../assets/images/pages/login/CaretLeft.svg";
import { toast } from "react-toastify";
import SelectComponent from "../../../components/shared/select/SelectComponent";
import { CountriesService } from "../../../services/countries.service";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";

function OtpCode() {
  const [countries, setCountries] = useState<CountriesDataType[]>([]);

  const [amazonOtp, setAmazonOtp] = useState<AmazonOtpDataType[]>([]);
  const [paginationData, setPaginationData] =
    useState<ApiPaginationResponse<AmazonOtpDataType> | null>(null);

  const [formValues, setFormValues] = useState({ track: "", otp: "" });
  const [selectedCountryId, setSelectedCountryId] = useState<number | null>(
    null
  );
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch<AppDispatch>();

  const language = useSelector((state: RootState) => state.language.language);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState<AmazonOtpDataType | null>(null);
  const [editForm, setEditForm] = useState<{
    otp_code: string;
    otp_text: string;
    country_id: number | undefined;
  }>({
    otp_code: "",
    otp_text: "",
    country_id: undefined,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    CountriesService.getAllCountries()
      .then((res) => {
        setCountries(res.data.original);
      })
      .catch(() => {
        toast.error(data?.error_occurred);
      });
  }, [language]);

  useEffect(() => {
    fetchOtpList();
  }, [language]);

  const fetchOtpList = async () => {
    try {
      setLoading(true);
      const res = await AmazonService.GetAmazonOtp();
      setAmazonOtp(res.data.data.data);
      setPaginationData(res.data.data);
    } catch {
      toast.error(data?.error_occurred);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditFormChange = (e: any) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditClick = (rowData: AmazonOtpDataType) => {
    setEditData(rowData);
    setEditForm({
      otp_code: rowData.otp_code || "",
      otp_text: rowData.otp_text || "",
      country_id: rowData.country_id ?? undefined,
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditData(null);
    setEditForm({ otp_code: "", otp_text: "", country_id: undefined });
  };

  const handleEditSubmit = async () => {
    if (!editData) return;

    if (!editForm.country_id) {
      toast.error(data?.auth_amazon_select_country);
      return;
    }

    const payload = {
      id: editData.id,
      otp_code: editForm.otp_code,
      otp_text: editForm.otp_text,
      country_id: editForm.country_id,
    };

    try {
      await AmazonService.EditAmazonOtp(payload);
      toast.success(data?.otp_updated);
      closeModal();
      await fetchOtpList();
    } catch {
      toast.error(data?.error_occurred);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormErrors({});
    setIsSubmitting(true);

    const payload = {
      otp_code: formValues.otp,
      otp_text: formValues.track,
      country_id: selectedCountryId,
    };

    try {
      await AmazonService.PostAmazonOtp(payload);
      toast.success(data?.otp_added);
      setFormValues({ track: "", otp: "" });
      setSelectedCountryId(null);
      await fetchOtpList();
    } catch (error: any) {
      setErrors(error.content || {});
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePageChange = async (urlOrPage: string | number) => {
    setLoading(true);
    try {
      let res;
      if (typeof urlOrPage === "string") {
        res = await AmazonService.GetAmazonOtp(urlOrPage);
      } else {
        const basePath = paginationData?.path || "/amazon/otp";
        const url = `${basePath}?page=${urlOrPage}`;
        res = await AmazonService.GetAmazonOtp(url);
      }
      setAmazonOtp(res.data.data.data);
      setPaginationData(res.data.data);
    } catch {
    } finally {
      setLoading(false);
    }
  };
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  return (
    <>
      <TitleUpdater
        title={
          data?.colibri && data?.auth_left_sidebar_amazon_otp
            ? `${data?.colibri} | ${data?.auth_left_sidebar_amazon_otp}`
            : "Colibri"
        }
      />
      <form className={styles.AmazonOtp} onSubmit={handleSubmit}>
        <div className={styles.customAllInputWrapper}>
 

          <div className={styles.customInputWrapperContainer}>
            <div className={styles.customInputWrapper}>
              <div className={styles.iconBlock}>
                <div className={styles.iconCircle}>
                  <img src={TransparationBalance} alt="otp" />
                </div>
              </div>
              <div className={styles.customInputContent}>
                <span>{data?.auth_amazon_otp_short}</span>
                {/* <InputComponent
                label=""
                type="text"
                name="otp"
                placeholder="000000"
                isPassword={false}
                value={formValues.otp}
                onChange={handleInputChange}
                error={errors.otp_code}
                className={styles.inputForOtp}
              /> */}

                <input
                  type="text"
                  name="otp"
                  placeholder="000000"
                  value={formValues.otp}
                  onChange={handleInputChange}
                  className={styles.inputForOtp}
                />
              </div>
            </div>
            {errors.otp_code && (
              <p className={styles.errorMsg}>{errors.otp_code}</p>
            )}
          </div>

                   <div className={styles.customInputWrapperContainer}>
            <div className={styles.customInputWrapper}>
              <div className={styles.iconBlock}>
                <div className={styles.iconCircle}>
                  <img src={ServiceBalance} alt="track" />
                </div>
              </div>
              <div className={styles.customInputContent}>
                <span>{data?.auth_amazon_track} </span>
                {/* <InputComponent
                label=""
                type="text"
                name="track"
                placeholder="00000"
                isPassword={false}
                value={formValues.track}
                onChange={handleInputChange}
                error={errors.otp_text}
                className={styles.inputForOtp}
              /> */}
                <input
                  type="text"
                  name="track"
                  placeholder="00000"
                  value={formValues.track}
                  onChange={handleInputChange}
                  className={styles.inputForOtp}
                />
              </div>
            </div>
            {errors.otp_text && (
              <p className={styles.errorMsg}>{errors.otp_text}</p>
            )}
          </div>

          <div className={styles.customInputWrapperContainer}>
            <div className={styles.customInputWrapper}>
              <div className={styles.iconBlock}>
                <div className={styles.iconCircle}>
                  <img src={TransparationBalance} alt="country" />
                </div>
              </div>
              <div className={styles.customInputContent}>
                <select
                  style={{ width: "100%" }}
                  name="tarif"
                  value={selectedCountryId ?? ""}
                  onChange={(e) => setSelectedCountryId(Number(e.target.value))}
                  className={styles.country}
                >
                  <option className={styles.countryValue} value="" disabled>
                    {data?.auth_amazon_select_country}
                  </option>
                  {countries
                    .filter((c) => [2, 9, 12].includes(c.id)) // 👈 yalnız bu id-lər buraxılır
                    .map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.title}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <p className={styles.errorMsg}>{errors.country_id}</p>
          </div>
        </div>

        <MainButton
          className={styles.form_submitBtn}
          text={data?.auth_amazon_confirm}
          type="submit"
          disabled={isSubmitting}
        />

        <div className={styles.pagination_part}>
          <p className={styles.pagination_title}>{data?.auth_amazon_history}</p>
          {(paginationData?.current_page === 1 &&
            paginationData?.next_page_url === null) ||
            (paginationData && (
              <div className={styles.pagination}>
                <img
                  src={ArrowImage}
                  className={`${styles.pagination_arrow_left} ${
                    !paginationData.prev_page_url ? styles.disabled : ""
                  }`}
                  alt="Prev"
                  onClick={() => {
                    if (paginationData.prev_page_url) {
                      handlePageChange(paginationData.prev_page_url);
                    }
                  }}
                />

                {[...Array(paginationData.last_page)].map((_, index) => {
                  const page = index + 1;
                  return (
                    <p
                      key={page}
                      className={`${styles.pagination_count} ${
                        paginationData.current_page === page
                          ? styles.active
                          : ""
                      }`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </p>
                  );
                })}

                <img
                  src={ArrowImage}
                  className={`${styles.pagination_arrow_right} ${
                    !paginationData.next_page_url ? styles.disabled : ""
                  }`}
                  alt="Next"
                  onClick={() => {
                    if (paginationData.next_page_url) {
                      handlePageChange(paginationData.next_page_url);
                    }
                  }}
                />
              </div>
            ))}
        </div>

        {loading ? (
          <div className={styles.loadingWrapper}>
            <Spinner size="large" />
          </div>
        ) : amazonOtp.length !== 0 ? (
          <table className={styles.order_history_list}>
            <thead>
              <tr>
                <th>{data?.auth_amazon_otp_short}</th>
                <th>{data?.message} </th>
                <th>{data?.country} </th>
                <th
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img src={amazoneditBtn} alt="" />
                  {data?.auth_table_header_edit}
                </th>
              </tr>
            </thead>
            <tbody>
              {amazonOtp.map((order, index) => (
                <OrderRow
                  key={index}
                  {...order}
                  onEdit={() => handleEditClick(order)}
                />
              ))}
            </tbody>
          </table>
        ) : (
          <div className={styles.empty_wrapper}>
            <div className={styles.empy_packages}>
              {data?.auth_amazon_empty}
            </div>
          </div>
        )}

        <div className={styles.courier_card}>
          {amazonOtp.map((order, index) => (
            <Card
              key={index}
              {...order}
              amazon={true}
              onEdit={() => handleEditClick(order)}
            />
          ))}
        </div>
      </form>

      {showModal && editData && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <button className={styles.closeButton} onClick={closeModal}>
              <img src={closeIcon} alt="Close" />
            </button>

            <h3>Düzəliş et</h3>

            <InputComponent
              label="Otp"
              type="text"
              name="otp_code"
              placeholder="OTP Code"
              value={editForm.otp_code}
              onChange={handleEditFormChange}
              isPassword={false}
            />
            <InputComponent
              label="Track"
              type="text"
              name="otp_text"
              placeholder="OTP Text"
              value={editForm.otp_text}
              onChange={handleEditFormChange}
              isPassword={false}
            />

            {/* Modal içindeki ülke seçimi */}
            <SelectComponent
              name="edit_country"
              options={countries
                .filter((c) => [2, 9, 12].includes(c.id)) // ✅ yalnız 2, 9, 12 id-ləri burax
                .map((c) => ({ label: c.title, value: c.id }))}
              value={editForm.country_id ?? "salma"}
              onChange={(val: any) =>
                setEditForm((prev) => ({ ...prev, country_id: val }))
              }
              selectedValue={editForm.country_id}
              // placeholder="Ölkə seçin"
              className={"home_calc_select"}
            />

            <div>
              <MainButton
                text={data?.save}
                type="button"
                onClick={handleEditSubmit}
                className={styles.closeBtnEdit}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default OtpCode;
